<template>
  <div
    class="intersection_wrapper"
    v-intersect="onintersect"
    :style="min_height?`min-height: ${min_height}`:''"
    >
    <slot :show="show" v-if="show || show_always"/>
  </div>
</template>
<script>
  export default {
    props: ['min_height', 'show_always'],
    data: () => ({
      show: false,
    }),
    methods: {
      onintersect(entries, observer, isIntersecting) {
        if (isIntersecting) {
          this.show = true;
        } else {
          this.show = false;
        }
      },
    }
  }
</script>
<style>
  .intersection_wrapper {
  }
</style>
